<script setup lang="ts">
import moment from 'moment';

const nowTime = ref(moment());

onMounted(() => {
  setInterval(() => {
   nowTime.value = moment();
  }, 1000);

})

</script>

<template>
  <div class="toc-design-header">
    <div class="title">
      통합관제시스템
    </div>
    <div class="info-wrapper">
      <div class="now-date">
        {{ nowTime.format('YYYY-MM-DD HH:mm:ss') }}
      </div>
    </div>
  </div>

  
</template>


<style lang="scss" scoped>
.toc-notification-popup{
  position: absolute;
  width: 300px;
  height: 500px;
  top: 35px;
  right: 0;
  background-color: #fff;
  z-index: 999;
  color: #000;
  border-radius: 10px;
  cursor: default;
  display: none;

  &.show{
    display: block;
  }

  & .title {
    border-top-left-radius: 10px;
    border-top-right-radius: 10px;
    background: #D9D9D9;
    padding: 0.5rem;
    color: var(--Black, #242E2C);
    /* Title/16px - Bold */
    font-family: Urbanist;
    font-size: 16px;
    font-style: normal;
    font-weight: 700;
    line-height: 120%; /* 19.2px */
    height: 40px;
  }

  & .contents {
    overflow: auto; 
    height: calc(100% - 40px);

    .event-wrapper {
      display: flex;
      align-items: center;
      padding: 5px 0px;

      &:hover {
        background-color: #e7e7e7;
        cursor: pointer;
      }

      .icon {
        width: 50px;
        display: flex;
        justify-content: center;
        padding: 5px;
        height: 50px;

        & .inIconWrapper{
          display: flex;
          justify-content: center;
          align-items: center;
          width: 100%;
          height: 40px;
          border-radius: 100%;
          background-color: #ffff00;
          &.normal{ background-color: #27ae60; }
          &.preparing{ background-color: #0084ff; }
          &.warning{ background-color: #ffa800; }
          &.down{ background-color: #a9a9a9; }
          &.fault{ background-color: #ff0000; }

          img{
            width: 25px;
            height: 25px;
          }
        }
      }

      & .txt {
        width: 80%;
        padding: 0px 10px;

        & .date {
          color: var(--Grey-10, #6B7271);
          /* xxSmall - Regular 10px - Urbanist */
          font-family: Urbanist;
          font-size: 12px;
          font-style: normal;
          font-weight: 400;
          line-height: 130%;
        }

        & .addr {
          color: var(--Black, #242E2C);
          /* Title/11px - Medium */
          font-family: Urbanist;
          font-size: 13px;
          font-style: normal;
          font-weight: 500;
          line-height: 130%; /* 14.3px */
        }

        & .fault {
          color: var(--Black, #242E2C);
          /* Title/11px - Medium */
          font-family: Urbanist;
          font-size: 13px;
          font-style: normal;
          font-weight: 500;
          line-height: 130%; /* 14.3px */
        }
      }
    }
  }
}

.toc-design-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 15px 20px;
  color: var(--main-header-text-color);
  border-left: 1px solid #ffffff73;

  & .info-wrapper {
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: flex-end;
    flex: 1;

    & .now-date {
      font-size: 14px;
      font-weight: 400;
      color: var(--main-header-text-color);
      margin-right: 2rem;
      text-align: left;
      white-space: nowrap;
    }

    & .pointer-section {
      // width: 100%;
      height: 30px;
      display: flex;
      justify-content: space-around;
      align-items: center;
      gap: 8px;

      & > * {
        height: 30px;
      }

      & .alarm-wrapper {
        position: relative;
        width: 30px;
        height: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
        background: #d9d9d9dc;
        border: none;
        border-radius: 100%;
        padding: 5px;
        cursor: pointer;
        transition: background-color 0.2s ease;

        &:hover {
          background-color: #f8f4d3;
        }

        & img {
          width: 24px;
          height: 24px;
        }

        & .noise {
          position: absolute;
          right: calc(100% - 12px);
          bottom: calc(100% - 12px);
          width: 18px;
          height: 18px;
          line-height: 18px;
          background-color: #f76829;
          border-radius: 100%;
          color: #FFF;
          text-align: center;
          font-size: 10px;
          font-weight: 600;
        }
      }
      // & .divider {
      //   background: #E4E4E7;
      //   width: 1px;
      //   height: 100%;
      // }

      & .user-info {
        cursor: pointer;
        display: flex;
        align-items: center;
      

        & .user-info-icon {
          background-color: #d9d9d942;
          width: 30px;
          height: 30px;
          border-radius: 100%;
        }
        
        .loginDropDown{
          display: none;
          position: absolute;
          width: 200px;
          height: 200px;
          top: 60px;
          right: 10px;
          background-color: #fff;
          border: 1px solid #313131;
          z-index: 999;
          &.show{
            display: block;
          }
        }

        // & .caret {
        //   width: 30px;
        //   height: 30px;
        //   background: url("@/assets/images/renewal/user-caret.svg") no-repeat scroll center;
        // }
      }
    }
    
  }
}
</style>